import audio1 from "@/assets/audio/1.mp3"
import audio2 from "@/assets/audio/2.wav"
import audio3 from "@/assets/audio/3.wav"
import audio4 from "@/assets/audio/4.wav"
import soundCheck from "@/assets/audio/sound-check.mp3"

export type SoundFile = {
   id: number
   label: string
   value: string
   src: string
   type: string
}

export type AlertSoundFrequency = {
   id: number
   label: string
   value: string
}

export const noSoundFile: SoundFile = {
   id: 0,
   label: "No sound",
   value: "none",
   src: "",
   type: "",
}

export const soundFiles: SoundFile[] = [
   {
      id: 1,
      label: "Sound 1",
      value: "1.mp3",
      src: audio1,
      type: "audio/mpeg",
   },
   {
      id: 2,
      label: "Sound 2",
      value: "2.wav",
      src: audio2,
      type: "audio/wav",
   },
   {
      id: 3,
      label: "Sound 3",
      value: "3.wav",
      src: audio3,
      type: "audio/wav",
   },
   {
      id: 4,
      label: "Sound 4",
      value: "4.wav",
      src: audio4,
      type: "audio/wav",
   },
]

export enum SoundFrequency {
   ONCE = "once",
   CONTINUOUS = "continuous",
}

export const alertFrequencyOptions: AlertSoundFrequency[] = [
   {
      id: 0,
      label: "Play once",
      value: SoundFrequency.ONCE,
   },
   {
      id: 1,
      label: "Continuous",
      value: SoundFrequency.CONTINUOUS,
   },
]

export { soundCheck }
